<template>
  <div class="cars">
    <div class="approve-box">
      <img class="approve" :src="img.approve">
      <div class="f-12">您的认证已提交，审核时间2-3个工作日完成</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      img:{
        approve: require('../../../assets/img/approve.png')
      }
    }
  },
  created () {
    this.$store.commit('param/show', false)
    let source = this.$store.state.param.source
    if(source == 3||source == 7) {
      this.$appService.isShowReturn({state: true})
    }
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {

  }
}
</script>

<style lang="scss">
.cars{
  padding: 15px;
  text-align: center;

  .approve-box{
    margin-top: 20%;
    
    .approve{
      width: 50px;
      height: 50px;
      margin-bottom: 20px;
    }
  }
    
}
</style>
